import { createCRUDHook } from './createCRUDHook';
import { DraftPartComponentDto } from 'utils/models';
import {
  TBL_DRAFT_PART_COMPONENT,
  CAN_ADD_DRAFT_SUB_PART,
} from './apiEndPoints';

interface DraftPartComponentCustomOperations {
  CanAddSubDraftPart: (
    mainPartId: number,
    subPartId: number
  ) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  DraftPartComponentDto,
  DraftPartComponentDto[],
  DraftPartComponentCustomOperations
>({
  entityName: 'DraftPartComponent',
  endpoint: TBL_DRAFT_PART_COMPONENT,

  customOperations: (auth) => ({
    CanAddSubDraftPart: async (
      mainPartId: number,
      subPartId: number
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_DRAFT_PART_COMPONENT +
            CAN_ADD_DRAFT_SUB_PART +
            `?mainPartId=${mainPartId}&subPartId=${subPartId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const DraftPartComponentContext = Context;
export const useDraftPartComponentManager = useManager;
export const useDraftPartComponent = useConsumer;
